import { notificationApi } from 'src/api';
import { AxiosRequestConfig } from 'axios';

import { TemplateListSearchParams } from './templates';

import {
  SystemTemplateContentWriteRequest,
  SystemTemplateModuleDto,
  SystemTemplateRecipientsWriteRequest,
  TemplateListResponseDto,
} from 'src/types';

export const getTemplateSummaryDefault = (config: AxiosRequestConfig = {}) =>
  notificationApi.get<SystemTemplateModuleDto[]>('/api/v1/templates/default/summary', config);

export const getTemplateListDefault = (params: TemplateListSearchParams, config: AxiosRequestConfig = {}) =>
  notificationApi.get<TemplateListResponseDto>('/api/v1/templates/default', { ...config, params });

export const enableDefaultTemplate = (templateId: string) =>
  notificationApi.patch<string>(`/api/v1/templates/default/${templateId}/enable`);

export const disableDefaultTemplate = (templateId: string) =>
  notificationApi.patch<string>(`/api/v1/templates/default/${templateId}/disable`);

export const updateDefaultTemplateRecipients = (data: SystemTemplateRecipientsWriteRequest) =>
  notificationApi.patch<string>('/api/v1/templates/default/recipients', data);

export const updateDefaultTemplateContent = (
  data: SystemTemplateContentWriteRequest,
  config: AxiosRequestConfig = {},
) => notificationApi.patch<string>('/api/v1/templates/default/content', data, config);
